import { createClient } from "../client";
import { Session } from "../utils/session";
import type { AuthResponse, FlowOptions } from "../types";

const client = createClient();

export async function sendOtp(email: string): Promise<AuthResponse> {
  return client.post("/v1/auth", {
    type: "email_otp_send",
    email
  });
}

export async function verifyOtp(email: string, otp: string, options?: FlowOptions): Promise<AuthResponse> {
  const res = await client.post("/v1/auth", {
    type: "email_otp_verify",
    email,
    otp
  });

  if (res.token) {
    Session.set(res.token);
    // Allow password creation if new user and dev allows it
    if (options?.allowPasswordIfNewUser && res.user?.is_new_user) {
      res.message = "User can now set password.";
    }
  }

  return res;
}

export async function setPassword(password: string): Promise<AuthResponse> {
  const token = Session.get();
  if (!token) return { success: false, message: "No active session." };

  const res = await client.post("/v1/auth", {
    type: "set_password",
    password,
    token
  });

  // Invalidate old session
  Session.clear();
  return res;
}
